module.exports = __webpack_public_path__ + "img/ls.12d4acb3.svg";